import { TemplateMetadataAPI, TemplateFormDataAPI } from "../templateMetadata";
import { MobileRowLayoutDTO } from "..";
import { EMPTY_SOR } from "../../../../globalConsts";

export const templateMetadataApiPLACEHOLDER: TemplateMetadataAPI = {
  id: 0,
  name: "",
  displayAs: "",
  tableId: 0,
  tableName: "",
  visible: false,
  moduleId: 0,
  moduleName: "",
  type: "overview",
  image: "",
  description: "",
  dataSourceId: 0,
  defaultSearchQuery: EMPTY_SOR,
  detailId: 0,
  detailIds: null,
  isHeg: false,
  childrenTemplatesIds: [],
  functionIds: [],
  Status: 0,
  StatusText: "",
  hasItems: false,
  columnFormat: {},
  columnFormatMobile: {},
  mobileRowLayout: {} as MobileRowLayoutDTO,
  desktopRowLayout: {} as MobileRowLayoutDTO,
  keyColName: "",
  columnOrder: {},
  order: 0,
  itemTemplates: {},
  kpiMetadata: {
    displayAsKpi: false,
    criticalThreshold: null,
    importantThreshold: null,
  },
};

export const templateRowPLACEHOLDER: TemplateFormDataAPI = {
  name: "test",
  displayAs: "",
  tableID: 0,
  moduleID: 0,
  visible: true,
  system: "db",
  image: "",
  description: "",
  type: "overview",
  translationsJSON: "",
};
